module.exports = __webpack_public_path__ + "static/img/image_news_over_07.95b408c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/news/image_news_over_07.png
// module id = 6W8j
// module chunks = 10